import React from "react";
import PropTypes from "prop-types";
import lodash from "lodash";

import Filtering from "./Filtering";
import ListCompleteForms from "./ListCompleteForms";

class CompletedForms extends React.Component {
  state = {
    forms: [],
    location: this.props.locations[0].id.toString(),
    name: "",
    accessLevel: this.props.accessLevels[0].key,
    query: "",
    formId: "",
    startDate: moment().add(-7, 'days').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  };

  delayLoading = lodash.debounce(() => {
    this.setState({ query: this.state.name });
  }, 400);

  render() {
    const { locations, accessLevels, dataFields, dataForms } = this.props;
    const { name, location, query, accessLevel, formId, startDate, endDate } = this.state;

    return (
      <div>
        <h1>Completed Forms</h1>

        <div>
          <Filtering
            name={name}
            startDate={startDate}
            endDate={endDate}
            location={location}
            accessLevel={accessLevel}
            locations={locations}
            accessLevels={accessLevels}
            dataForms={dataForms}
            formId={formId}
            onChange={this.handlerChange}
            addFormOpen={this.props.addFormOpen}
          />
        </div>

        <ListCompleteForms
          query={query}
          location={location}
          accessLevel={accessLevel}
          formId={formId}
          dataFields={dataFields}
          startDate={startDate}
          endDate={endDate}
        />
      </div>
    );
  }

  handlerChange = e => {
    const name = e.target.name;
    const value = e.target.value;

    this.setState({ [name]: value }, () => {
      this.delayLoading();
    });
  };
}

CompletedForms.propTypes = {
  locations: PropTypes.array,
  accessLevels: PropTypes.array,
  dataFields: PropTypes.array,
  dataForms: PropTypes.array,
  addFormOpen: PropTypes.bool
};

export default CompletedForms;
